import { merge } from 'lodash';
import { UserMachine } from '~/machines/user-creation';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { Card, CardProps } from './card.component';

type CardContainerProps = {
  micro: ContextSendMatch<UserMachine>;
  overrideCopy?: CardProps['overrideCopy'];
  overrideProps?: DeepPartial<CardProps>;
};

export const CardContainer = ({
  micro: { context, send },
  overrideCopy,
  overrideProps,
}: CardContainerProps) => {
  const props: CardProps = {
    context,
    overrideCopy,
    skip: () => send({ type: 'SKIP' }),
    next: () => send({ type: 'NEXT' }),
  };
  return <Card {...merge(props, overrideProps)} />;
};
